import { getEnvVariable } from '../../../modules/environmentalList';
import UserAdd from './usersgrid';

const SelectProjectMgs = {
    "type": "form",
    "key": "SelectProjectMgs",
    "name": "SelectProjectMgs",
    aliases: {
        save: 'save',
    },
    sharedValues: ['save', 'SubModuleKey', 'SitePermitTypeId', 'SITE', 'ROLES', 'Users', 'FlowIds', 'CurrentlyAssigned', 'Futureworkflow', 'InfoText'],
    layout: {
        group: [
            {
                order: 0,
                type: 'div',
                className: 'row',
                components: [
                    {
                        name: 'SubModuleKey',
                        type: 'div',
                        className: 'col-2',
                        sub: {
                            type: 'div',
                            className: 'col-2'
                        }
                    },
                    {
                        name: 'SitePermitTypeId',
                        type: 'div',
                        className: 'col-2',
                        sub: {
                            type: 'div',
                            className: 'col-2'
                        }
                    },
                    {
                        name: 'SITE',
                        type: 'div',
                        className: 'col-2',
                        sub: {
                            type: 'div',
                            className: 'col-2',
                        }
                    },
                    {
                        name: 'ROLES',
                        type: 'div',
                        className: 'col-3',
                        sub: {
                            type: 'div',
                            className: 'col-3',
                        },
                    },
                    {
                        name: 'Users',
                        type: 'div',
                        className: 'col-2',
                        sub: {
                            type: 'div',
                            className: 'col-2',
                        }
                    },
                ],
            },
            {
                order: 1,
                type: 'div',
                className: 'row',
                components: [
                    {
                        name: 'FlowIds',
                        type: 'div',
                        className: 'col-1',
                        sub: {
                            type: 'div',
                            className: 'col-1',
                        }
                    },
                    {
                        name: 'CurrentlyAssigned',
                        type: 'div',
                        className: 'col-2',
                        sub: {
                            type: 'div',
                            className: 'col-2',
                        }
                    },
                    {
                        name: 'Futureworkflow',
                        type: 'div',
                        className: 'col-2',
                        sub: {
                            type: 'div',
                            className: 'col-2',
                        }
                    },

                ],
            },
        ],
    },
    values: {
        SubModuleKey: '',
        SitePermitTypeId: '',
        SITE: '',
        ROLES: '',
        Users: '',
        CurrentlyAssigned: 'Y',
        Futureworkflow: 'Y',
        FlowIds: [],
        InfoText: ''
    },

    "components": {
        SubModuleKey: {
            "type": "dropdown",
            "key": "SubModuleKey",
            "label": "Sub Module",
            "name": "SubModuleKey",
            isVisible: false,
            extraProps: {
                transformProps: {
                    label: 'SubModuleName',
                    value: 'Key'
                },
            },
        },
        SitePermitTypeId: {
            "type": "dropdown",
            "key": "SitePermitTypeId",
            "label": "Permit Type",
            "name": "SitePermitTypeId",
            extraProps: {
                transformProps: {
                    label: 'Name',
                    value: 'Id'
                },
            },
        },
        SITE: {
            "type": "dropdown",
            "key": "SITE",
            "label": "Select County",
            "name": "SITE",
            extraProps: {
                transformProps: {
                    label: 'Name',
                    value: 'Id'
                },
            }
        },
        ROLES: {
            "type": "dropdown",
            "key": "ROLES",
            "label": "Select Role",
            "name": "ROLES",
            extraProps: {
                transformProps: {
                    label: 'Name',
                    value: 'Id'
                },
            }
        },
        Users: {
            "type": "dropdown",
            "key": "Users",
            "label": "Select User",
            "name": "Users",
            extraProps: {
                transformProps: {
                    label: 'FullName',
                    value: 'UserId'
                },
            }
        },
        FlowIds: {
            "type": "workflowitems",
            "key": "FlowIds",
            "label": "Flow Ids",
            "name": "FlowIds",
            "icontooltip": "Flow Ids",
            isVisible: false
        },
        CurrentlyAssigned: {
            "type": "checkbox",
            "key": "CurrentlyAssigned",
            "label": "Currently Assigned",
            "name": "CurrentlyAssigned",
            "iconcolor": "secondary",
            "icontooltip": "Currently Assigned",
            "isicon": true,
        },
        Futureworkflow: {
            "type": "checkbox",
            "key": "Futureworkflow",
            "label": "Future workflow",
            "name": "Futureworkflow",
            "icontooltip": "Future workflow",
            "isicon": true,
        },
        InfoText: {
            "type": "label",
            "key": "InfoText",
            "label": "NOTE: Please inactivate selected user before switching",
            "name": "InfoText",
            changefieldto: "label",
        },
    },
    // mapActionsToEffects: {
    //     onLoad: {
    //         init: {
    //             rules: [
    //                 {
    //                     run: {
    //                         valid: [
    //                             {
    //                                 type: 'load',
    //                                 name: 'SubModuleKey',
    //                                 read: [
    //                                     {
    //                                         url: `${getEnvVariable('MasterAdmin')}/api/module/${getEnvVariable('ModuleKey')}/submodule/All/Active/IsConfigurable`,
    //                                         type: 'get',
    //                                         saveAs: {
    //                                             key: 'items',
    //                                         },
    //                                     },
    //                                 ],
    //                             },
    //                             {
    //                                 type: 'load',
    //                                 name: 'SITE',
    //                                 read: [
    //                                     {
    //                                         url: `${getEnvVariable('AdminConfig')}/api/SitePermitTypesConfig/{SitePermitTypeId}/Sites`,
    //                                         matchProps: [
    //                                             {
    //                                                 name: 'SitePermitTypeId',
    //                                                 key: 'SitePermitTypeId',
    //                                             },
    //                                         ],
    //                                         type: 'get',
    //                                         saveAs: {
    //                                             key: 'items',
    //                                         },
    //                                     },
    //                                 ],
    //                             },
    //                         ],
    //                     },
    //                 },
    //                 {
    //                     check: [
    //                         {
    //                             condition: 'AND',
    //                             rules: [
    //                                 {
    //                                     name: 'SITE',
    //                                     type: 'is null',
    //                                     rules: [],
    //                                 },
    //                             ],
    //                         },
    //                     ],
    //                     uncheck: true,
    //                     run: {
    //                         valid: [
    //                             {
    //                                 type: 'prop',
    //                                 name: 'ROLES',
    //                                 disabled: true,
    //                             },
    //                             {
    //                                 type: 'prop',
    //                                 name: 'Users',
    //                                 disabled: true,
    //                             },
    //                             {
    //                                 type: 'prop',
    //                                 name: 'FlowIds',
    //                                 isVisible: false,
    //                             },
    //                         ],
    //                     },
    //                 },
    //             ],
    //         },
    //     },
    //     onChange: {
    //         SubModuleKey: {
    //             rules: [
    //                 {
    //                     canOverwrite: true,
    //                     check: [
    //                         {
    //                             condition: 'AND',
    //                             rules: [
    //                                 {
    //                                     name: 'SubModuleKey',
    //                                     type: '!=',
    //                                     value: '',
    //                                     rules: [],
    //                                 },
    //                             ],
    //                         },
    //                     ],
    //                     fields: ['SubModuleKey'],
    //                     run: {
    //                         type: 'check',
    //                         valid: [
    //                             {
    //                                 type: 'load',
    //                                 name: 'SitePermitTypeId',
    //                                 read: [
    //                                     {
    //                                         url: `${getEnvVariable('AdminConfig')}/api/SitePermitTypes/SubModuleKey/Active/{SubModuleKey}`,
    //                                         type: 'get',
    //                                         matchProps: [
    //                                             {
    //                                                 name: 'SubModuleKey',
    //                                                 key: 'SubModuleKey',
    //                                             },
    //                                         ],
    //                                         saveAs: {
    //                                             key: 'items',
    //                                         },
    //                                     },
    //                                 ],
    //                             },
    //                         ],
    //                         invalid: [],
    //                     },
    //                     uncheck: false,
    //                 },
    //             ],
    //             fields: ['SubModuleKey'],
    //         },
    //         SitePermitTypeId: {
    //             rules: [
    //                 {
    //                     fields: ['SitePermitTypeId'],
    //                     check: [
    //                         {
    //                             condition: 'AND',
    //                             rules: [
    //                                 {
    //                                     name: 'SitePermitTypeId',
    //                                     type: 'is not null',
    //                                     rules: [],
    //                                 },
    //                             ],
    //                         },
    //                     ],
    //                     run: {
    //                         valid: [
    //                             {
    //                                 type: 'load',
    //                                 name: 'SITE',
    //                                 read: [
    //                                     {
    //                                         url: `${getEnvVariable('AdminConfig')}/api/SitePermitTypesConfig/{SitePermitTypeId}/Sites`,
    //                                         type: 'get',
    //                                         matchProps: [
    //                                             {
    //                                                 name: 'SitePermitTypeId',
    //                                                 key: 'SitePermitTypeId',
    //                                             },
    //                                         ],
    //                                         saveAs: {
    //                                             key: 'items',
    //                                         },
    //                                     },
    //                                 ],
    //                             },
    //                             {
    //                                 type: 'prop',
    //                                 name: 'SITE',
    //                                 disabled: false,
    //                             },
    //                         ],
    //                     },
    //                 },
    //             ],
    //             fields: ['SitePermitTypeId'],
    //         },
    //         SITE: {
    //             rules: [
    //                 {
    //                     fields: ['SITE'],
    //                     check: [
    //                         {
    //                             condition: 'AND',
    //                             rules: [
    //                                 {
    //                                     name: 'SITE',
    //                                     type: 'is not null',
    //                                     rules: [],
    //                                 },
    //                             ],
    //                         },
    //                     ],
    //                     run: {
    //                         valid: [
    //                             {
    //                                 type: 'load',
    //                                 name: 'ROLES',
    //                                 read: [
    //                                     {
    //                                         url: `${getEnvVariable('Admin')}/api/Roles/${getEnvVariable('ConfigType')}/{SITE}/RolesDataBasedonConfigType`,
    //                                         type: 'get',
    //                                         matchProps: [
    //                                             {
    //                                                 name: 'SITE',
    //                                                 key: 'SITE',
    //                                             },
    //                                         ],
    //                                         saveAs: {
    //                                             key: 'items',
    //                                         },
    //                                     },
    //                                 ],
    //                             },
    //                             {
    //                                 type: 'prop',
    //                                 name: 'ROLES',
    //                                 disabled: false,
    //                             },
    //                         ],
    //                     },
    //                 },
    //             ],
    //             fields: ['SITE'],
    //         },
    //         ROLES: {
    //             rules: [
    //                 {
    //                     fields: ['ROLES'],
    //                     check: [
    //                         {
    //                             condition: 'AND',
    //                             rules: [
    //                                 { name: 'SITE', type: 'is not null', rules: [] },
    //                                 { name: 'ROLES', type: 'is not null', rules: [] },
    //                             ],
    //                         },
    //                     ],
    //                     run: {
    //                         valid: [
    //                             {
    //                                 type: 'load',
    //                                 name: 'Users',
    //                                 read: [
    //                                     {
    //                                         url: `${getEnvVariable('MasterAdmin')}/api/InternalAccessControlView/GetUsersByConfigIdAndRoleId/{SITE}/${getEnvVariable('ConfigType')}/{ROLES}/${getEnvVariable('ModuleKey')}`,
    //                                         type: 'get',
    //                                         matchProps: [
    //                                             {
    //                                                 name: 'SITE',
    //                                                 key: 'SITE',
    //                                             },
    //                                             {
    //                                                 name: 'ROLES',
    //                                                 key: 'ROLES',
    //                                             },
    //                                         ],
    //                                         saveAs: {
    //                                             key: 'items',
    //                                         },
    //                                     },
    //                                 ],
    //                             },
    //                             {
    //                                 type: 'prop',
    //                                 name: 'Users',
    //                                 disabled: false,
    //                             },
    //                         ],
    //                     },
    //                 },
    //             ],
    //             fields: ['SITE', 'ROLES'],
    //         },
    //         Users: {
    //             rules: [
    //                 {
    //                     canOverwrite: true,
    //                     check: [
    //                         {
    //                             condition: 'AND',
    //                             rules: [
    //                                 { name: 'SITE', type: 'is not null', rules: [] },
    //                                 { name: 'ROLES', type: 'is not null', rules: [] },
    //                                 { name: 'Users', type: 'is not null', rules: [] },
    //                             ],
    //                         },
    //                     ],
    //                     fields: ['Users'],
    //                     run: {
    //                         type: 'check',
    //                         valid: [],
    //                     },
    //                     uncheck: false,
    //                 },
    //             ],
    //             fields: ['Users'],
    //         },
    //     },
    // }
    mapActionsToEffects: {
        onLoad: {
            init: {
                rules: [
                    {
                        run: {
                            valid: [
                                {
                                    type: 'load',
                                    name: 'SubModuleKey',
                                    read: [
                                        {
                                            url: `${getEnvVariable('MasterAdmin')}/api/module/${getEnvVariable('ModuleKey')}/submodule/All/Active/IsConfigurable`,
                                            type: 'get',
                                            saveAs: {
                                                key: 'items',
                                            },
                                        },
                                    ],
                                },
                                {
                                    type: 'load',
                                    name: 'SitePermitTypeId',
                                    read: [
                                        {
                                            url: `${getEnvVariable('AdminConfig')}/api/SitePermitTypes/SubModuleKey/Active/{SubModuleKey}`,
                                            type: 'get',
                                            matchProps: [
                                                {
                                                    name: 'SubModuleKey',
                                                    key: 'SubModuleKey',
                                                },
                                            ],
                                            saveAs: {
                                                key: 'items',
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    },
                    {
                        check: [
                            {
                                condition: 'AND',
                                rules: [
                                    {
                                        name: 'SITE',
                                        type: 'is null',
                                        rules: [],
                                    },
                                ],
                            },
                        ],
                        uncheck: true,
                        run: {
                            valid: [
                                {
                                    type: 'prop',
                                    name: 'ROLES',
                                    disabled: true,
                                },
                                {
                                    type: 'prop',
                                    name: 'Users',
                                    disabled: true,
                                },
                                {
                                    type: 'prop',
                                    name: 'FlowIds',
                                    isVisible: false,
                                },
                            ],
                        },
                    },
                ],
            },
        },
        onChange: {
            SubModuleKey: {
                rules: [
                    {
                        canOverwrite: true,
                        check: [
                            {
                                condition: 'AND',
                                rules: [
                                    {
                                        name: 'SubModuleKey',
                                        type: '!=',
                                        value: '',
                                        rules: [],
                                    },
                                ],
                            },
                        ],
                        fields: ['SubModuleKey'],
                        run: {
                            type: 'check',
                            valid: [
                                {
                                    type: 'load',
                                    name: 'SitePermitTypeId',
                                    read: [
                                        {
                                            url: `${getEnvVariable('AdminConfig')}/api/SitePermitTypes/SubModuleKey/Active/{SubModuleKey}`,
                                            type: 'get',
                                            matchProps: [
                                                {
                                                    name: 'SubModuleKey',
                                                    key: 'SubModuleKey',
                                                },
                                            ],
                                            saveAs: {
                                                key: 'items',
                                            },
                                        },
                                    ],
                                },
                            ],
                            invalid: [],
                        },
                        uncheck: false,
                    },
                ],
                fields: ['SubModuleKey'],
            },
            SitePermitTypeId: {
                rules: [
                    {
                        fields: ['SitePermitTypeId'],
                        check: [
                            {
                                condition: 'AND',
                                rules: [
                                    {
                                        name: 'SitePermitTypeId',
                                        type: 'is not null',
                                        rules: [],
                                    },
                                ],
                            },
                        ],
                        run: {
                            valid: [
                                {
                                    type: 'load',
                                    name: 'SITE',
                                    read: [
                                        {
                                            url: `${getEnvVariable('AdminConfig')}/api/SitePermitTypesConfig/{SitePermitTypeId}/Sites`,
                                            type: 'get',
                                            matchProps: [
                                                {
                                                    name: 'SitePermitTypeId',
                                                    key: 'SitePermitTypeId',
                                                },
                                            ],
                                            saveAs: {
                                                key: 'items',
                                            },
                                        },
                                    ],
                                },
                                {
                                    type: 'prop',
                                    name: 'SITE',
                                    disabled: false,
                                },
                            ],
                        },
                    },
                ],
                fields: ['SitePermitTypeId'],
            },
            SITE: {
                rules: [
                    {
                        fields: ['SITE'],
                        check: [
                            {
                                condition: 'AND',
                                rules: [
                                    {
                                        name: 'SITE',
                                        type: 'is not null',
                                        rules: [],
                                    },
                                ],
                            },
                        ],
                        run: {
                            valid: [
                                {
                                    type: 'load',
                                    name: 'ROLES',
                                    read: [
                                        {
                                            url: `${getEnvVariable('Admin')}/api/Roles/${getEnvVariable('ConfigType')}/{SITE}/RolesDataBasedonConfigType`,
                                            type: 'get',
                                            matchProps: [
                                                {
                                                    name: 'SITE',
                                                    key: 'SITE',
                                                },
                                            ],
                                            saveAs: {
                                                key: 'items',
                                            },
                                        },
                                    ],
                                },
                                {
                                    type: 'prop',
                                    name: 'ROLES',
                                    disabled: false,
                                },
                            ],
                        },
                    },
                ],
                fields: ['SITE'],
            },
            ROLES: {
                rules: [
                    {
                        fields: ['ROLES'],
                        check: [
                            {
                                condition: 'AND',
                                rules: [
                                    { name: 'SITE', type: 'is not null', rules: [] },
                                    { name: 'ROLES', type: 'is not null', rules: [] },
                                ],
                            },
                        ],
                        run: {
                            valid: [
                                {
                                    type: 'load',
                                    name: 'Users',
                                    read: [
                                        {
                                            url: `${getEnvVariable('MasterAdmin')}/api/InternalAccessControlView/GetUsersByConfigIdAndRoleId/{SITE}/${getEnvVariable('ConfigType')}/{ROLES}/${getEnvVariable('ModuleKey')}`,
                                            type: 'get',
                                            matchProps: [
                                                {
                                                    name: 'SITE',
                                                    key: 'SITE',
                                                },
                                                {
                                                    name: 'ROLES',
                                                    key: 'ROLES',
                                                },
                                            ],
                                            saveAs: {
                                                key: 'items',
                                            },
                                        },
                                    ],
                                },
                                {
                                    type: 'prop',
                                    name: 'Users',
                                    disabled: false,
                                },
                            ],
                        },
                    },
                ],
                fields: ['SITE', 'ROLES'],
            },
            Users: {
                rules: [
                    {
                        canOverwrite: true,
                        check: [
                            {
                                condition: 'AND',
                                rules: [
                                    { name: 'SITE', type: 'is not null', rules: [] },
                                    { name: 'ROLES', type: 'is not null', rules: [] },
                                    { name: 'Users', type: 'is not null', rules: [] },
                                ],
                            },
                        ],
                        fields: ['Users'],
                        run: {
                            type: 'check',
                            valid: [],
                        },
                        uncheck: false,
                    },
                ],
                fields: ['Users'],
            },
        },
    }
}

const SwitchuserGrid = {
    "title": "Permits",
    "type": "grid",
    "key": "SwitchuserGrid",
    "gridkey": 'SwitchuserGrid',
    "name": "SwitchuserGrid",
    "hasreport": true,
    "addRoute": true,
    "routeParams": { replace: 'permits', param: 'Id', routeName: 'id' },
    values: {
        switchOpen: false,
        addOpen: false,
        editOpen: false,
        editInfo: null,
        load: false,
        allgriddata: null,
        navigateItem: null,
        navigation: null,
        reportOpen: false,
        loadreportfilter: null,
        ReportJsonQueryStr: null,
    },
    sharedValues: ['switchOpen', 'addOpen', 'editOpen', 'editInfo', 'allgriddata', 'navigateItem', 'navigation',
        'loadreportfilter', 'ReportJsonQueryStr', 'reportOpen', 'FlowIds', 'SubModuleKey', 'SitePermitTypeId'],
    aliases: {
        switchOpen: 'switchOpen',
        addOpen: 'addOpen',
        editOpen: 'editOpen',
        editInfo: 'editInfo',
        allgriddata: 'allgriddata',
        navigateItem: 'navigateItem',
        navigation: 'navigation',
        reportOpen: 'reportOpen',
        loadreportfilter: 'loadreportfilter',
        ReportJsonQueryStr: 'ReportJsonQueryStr',
        FlowIds: 'FlowIds',
        SubModuleKey: 'SubModuleKey',
        SitePermitTypeId: 'SitePermitTypeId'
    },
    headerProps: {
        title: "Switch Workflow",
        components: [
            {
                type: 'breadcrumbs',
                items: [
                    { "link": "Dashboard", "tab": 'D', "materialicon": "dashboard", href: getEnvVariable('InternalBasepath'), className: 'breadcrumb-item text-dark', class: 'text-dark' },
                    { "link": "Switch Workflow User", href: "/Administration/switchworkflow", "materialicon": "person_add", className: 'breadcrumb-item ', class: '' },
                ],
            }
        ],
        actions: [
            {
                type: 'icon',
                icon: 'loadresults',
                name: 'loadresults',
                color: 'primary',
                title: 'Load Results',
                hideon: 'loadresults',
                hidevalue: false,
            },
            {
                type: 'icon',
                icon: 'switchuser',
                color: 'primary',
                name: 'switchuser',
                hideon: 'switchuser',
                hidevalue: true,
                title: 'Switch Workflow'
            },
        ]
    },
    "columns": [
        {
            "title": "",
            "field": "selected",
            "show": true,
        },
        {
            "title": "Tracking Number",
            "field": "Record Number",
            "show": true,
        },
        {
            "title": "County",
            "field": "Site IdDesc",
            "show": true,
        },
        {
            "title": "Applicant Name",
            "field": "Applicant Name",
            "show": true,
        },
        {
            "title": "Process Transition Status",
            "field": "Application StatusDesc",
            "show": true,
        },
    ],

    displayName: 'editInfo',
    allgriddata: 'allgriddata',
    navigateItem: 'navigateItem',
    navigation: 'navigation',
    loadreportfilter: 'loadreportfilter',
    ReportJsonQueryStr: 'ReportJsonQueryStr',
    mapActionsToEffects: {
        switchOpen: {
            rules: [{
                check: [
                    {
                        condition: 'AND',
                        rules: [
                            {
                                "name": "switchOpen",
                                "type": "!=",
                                "value": true,
                                "rules": []
                            }
                        ]
                    }
                ],
                run: {
                    valid: [

                    ]
                }
            }]
        },
        'switchuser': {
            rules: [
                {
                    run: {
                        valid: [
                            {
                                type: 'value',
                                key: 'switchOpen',
                                result: true
                            },

                        ]
                    }
                }
            ]
        },
        'loadresults': {
            rules: [
                {
                    run: {
                        valid: [{
                            type: 'grid',
                            "read": [
                                {
                                    url: getEnvVariable('Application') + `/api/Application/All/{SubModuleKey}/WorkflowIds/{SitePermitTypeId}?`,
                                    type: 'post',
                                    alert: true,
                                    key: 'save',
                                    body: {
                                        "FlowIds": 'FlowIds'
                                    },
                                    removeObjPropertyKey: ['FlowIds'],
                                    replaceBody: true,
                                    word: "FlowIds",
                                    "matchProps": [
                                        {
                                            name: "FlowIds",
                                            key: "FlowIds",
                                        }, {
                                            name: "SitePermitTypeId",
                                            key: "SitePermitTypeId",
                                        },
                                        {
                                            name: "SubModuleKey",
                                            key: "SubModuleKey",
                                        },
                                    ],
                                    saveAs: {
                                        key: 'data',
                                    }
                                }
                            ]
                        },
                        ]
                    }
                }
            ]
        },
    }
}

const SwitchuserContainer = {
    type: 'container',
    key: 'SwitchuserContainer',
    values: {
    },
    mapValues: {
        UserAdd: [
            {
                key: 'switchOpen',
                name: 'open'
            },
            {
                key: 'SubModuleKey',
                name: 'SubModuleKey'
            },
            {
                key: 'SitePermitTypeId',
                name: 'SitePermitTypeId'
            },
            {
                key: 'SITE',
                name: 'SITE'
            },
            {
                key: 'ROLES',
                name: 'ROLES'
            },
            {
                key: 'Users',
                name: 'Users'
            },
            {
                key: 'CurrentlyAssigned',
                name: 'CurrentlyAssigned'
            },
            {
                key: 'Futureworkflow',
                name: 'Futureworkflow'
            },
            {
                key: 'FlowIds',
                name: 'FlowIds'
            },
        ],
        SwitchuserGrid: [
            {
                key: 'switchOpen',
                name: 'switchOpen'
            },
            {
                key: 'FlowIds',
                name: 'FlowIds'
            },
            {
                key: 'SubModuleKey',
                name: 'SubModuleKey'
            },
            {
                key: 'SitePermitTypeId',
                name: 'SitePermitTypeId'
            },
        ],
        SelectProjectMgs: [
            {
                key: 'SITE',
                name: 'SITE'
            },
            {
                key: 'FlowIds',
                name: 'FlowIds'
            },
        ],

    },
    mapActionsToEffects: {
        'switchOpen': {
            rules: [
                {
                    check: [
                        {
                            condition: 'AND',
                            rules: [
                                {
                                    "name": "switchOpen",
                                    "type": "!=",
                                    "value": true,
                                    "rules": []
                                }
                            ]
                        }
                    ],
                    uncheck: true,
                    run: {
                        valid: [
                            {
                                type: 'removelayout',
                                name: 'UserAdd',
                            }

                        ],
                        inValid: [
                            {
                                type: 'addlayout',
                                name: 'UserAdd',
                            }
                        ]
                    }
                }
            ]
        },

    },
    layout: {
        group: [
            {
                order: 0,
                type: 'div',
                className: 'row',
                components: [
                    {
                        name: 'SelectProjectMgs',
                        type: 'div',
                        className: 'col-12',
                        sub: {
                            type: 'div',
                            className: 'col-12',
                        }
                    },
                ]
            },
            {
                order: 1,
                type: 'div',
                className: 'row',
                components: [
                    {
                        name: 'SwitchuserGrid'
                    },
                ]
            }
        ]

    },
    components: {
        SelectProjectMgs: SelectProjectMgs,
        SwitchuserGrid: SwitchuserGrid,
        UserAdd: UserAdd,
    }
}


export default SwitchuserContainer